import { useEntityUrl } from 'framework/routing';
import { CANDIDATES_PATH } from '../constants';

export const useCandidateUrl = () => {
  const entityUrl = useEntityUrl({
    baseLink: CANDIDATES_PATH,
    editPostfix: 'profile/edit',
  });

  const { getSingleEntityUrl } = entityUrl;

  return {
    ...entityUrl,
    getSingleEntityUrl,
    getProfileUrl: (id?: string) => `${getSingleEntityUrl(id)}/profile`,
    getProfileEditUrl: (id: StringOrNumber) => `${getSingleEntityUrl(id)}/personal-legal/edit`,
    getCommunicationUrl: (id: StringOrNumber) => `${getSingleEntityUrl(id)}/communication`,
    getApplicationsUrl: (id: StringOrNumber) => `${getSingleEntityUrl(id)}/applications`,
  };
};
